





import { PageMode } from '@/main/utils/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { isVozidloSet } from '../../utils';
import { store } from '../../store/edit';

export default PageModeMixin.extend({
	name: 'ZakazkaCisloSchvaleniInput',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		isDisabled() {
			return !isVozidloSet(this.ZakazkaDruh!, this.VozidloId!) || this.$route.params.mode === PageMode.VIEW;
		},
	},
});
